import netsIframe from './nets-iframe';
import moduleConfig from './module-config';

export default angular
  .module('app.iframe', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsIframe', netsIframe);
